<script setup lang="ts">
import { useIosLayout } from '@/abs-core/shared/composables/useIosLayout'
import { computed, onMounted } from 'vue'
import { IonApp, IonRouterOutlet, isPlatform } from '@ionic/vue'

const { adjustLayout } = useIosLayout()
const isIPhone = computed(() => {
  return isPlatform('iphone')
})

onMounted(() => {
  adjustLayout()
})
</script>

<template>
  <ion-app :class="{ 'iphone-device': isIPhone }" data-app-root="">
    <ion-router-outlet />
  </ion-app>
</template>

<style>
@import '@/abs-core/shared/styles/main.css';
</style>
